import { NgModule } from '@angular/core';
import { RadioComponent } from './radio.component';
import { CommonModule } from '@angular/common';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TypographyComponentModule } from '../typography/typography.module';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [RadioComponent],
  imports: [CommonModule, RadioButtonModule, TypographyComponentModule, FormsModule],
  exports: [RadioButtonModule, RadioComponent]
})
export class RadioComponentModule {}
